import { render, staticRenderFns } from "./RowDetailsInput.vue?vue&type=template&id=76f69688"
import script from "./RowDetailsInput.vue?vue&type=script&lang=js"
export * from "./RowDetailsInput.vue?vue&type=script&lang=js"
import style0 from "./RowDetailsInput.vue?vue&type=style&index=0&id=76f69688&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76f69688')) {
      api.createRecord('76f69688', component.options)
    } else {
      api.reload('76f69688', component.options)
    }
    module.hot.accept("./RowDetailsInput.vue?vue&type=template&id=76f69688", function () {
      api.rerender('76f69688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/productiveAreas/detail/component/RowDetailsInput.vue"
export default component.exports